import {
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormLabel,
  Modal,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import {
  ModalDrawerButtonStyles,
  ModalDrawerStyles,
  ModalHeader,
} from "../../../../Common/styles/modal";
import { LabelStyle, InputWrapper } from "./../../../../Common/styles/form";
import { useAppDispatch } from "../../../../../Redux/hooks";
import {
  setShowModal,
  setToggleLoader,
} from "../../../../../Redux/reducers/appCustomizationSlice";
import { errorToastMessage, toastMessage } from "../../../../../utils/toast";
import { DrawerForm } from "./../../../../Common/styles/drawer";
import http from "../../../../../utils/http";
import { useParams } from "react-router-dom";

const AddUrlModal = () => {
  const [url, setUrl] = useState<string>("");
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const { id: studyId } = useParams();
  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(setShowModal(false));
  };

  const refreshPage = () => {
    dispatch(setToggleLoader());
  };

  const submitHandler = async () => {
    try {
      if (!url.trim()) {
        toastMessage("error", "URL is required");
        return;
      }
      setSubmitLoader(true);
      await http.get(`study/${studyId}/dashboard`);
      console.log(url);
      closeModal();
      refreshPage();
    } catch (e) {
      errorToastMessage(e as Error);
    } finally {
      setSubmitLoader(false);
    }
  };

  return (
    <Modal open={true} onClose={closeModal}>
      <Box sx={ModalDrawerStyles}>
        <ModalHeader title={"Add URL"} onCloseClick={closeModal} />
        <Box sx={DrawerForm}>
          <Box>
            <FormControl sx={InputWrapper}>
              <FormLabel sx={LabelStyle} htmlFor="url">
                URL <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <TextField
                id="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                multiline
                fullWidth
                placeholder="Enter URL"
              />
            </FormControl>
          </Box>
          <Box sx={{ mt: "auto" }}>
            <Divider />
            <Box sx={ModalDrawerButtonStyles}>
              {!submitLoader ? (
                <>
                  <Button variant="outlined" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={!url}
                    onClick={submitHandler}
                  >
                    Save
                  </Button>
                </>
              ) : (
                <CircularProgress size={25} />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddUrlModal;
